/* rb-b-shoes.js — one chip per shoe size, in numeric order. CUSTOMER-SIDE ONLY.

   CHANGES NOTHING IN SHOPIFY. Like rb-b-sizeclean.js it hides and relabels rows
   the theme already rendered, and drives the theme's own checkboxes.

   WHAT IT FIXES, measured on /collections/all: the Shoe Sizes bucket rendered
   15 chips for 8 real sizes, because most sizes exist in the catalog both plain
   and with a EU suffix, and the two are separate filter values:

     8 (1) | 9.5 (3) | 9 (EU 42) (22) | 9 (22) | 10.5 (3) | 10 (EU 43) (25)
     10 (27) | 11 (EU 44) (25) | 11 (26) | 12 (EU 45) (16) | 12 (EU 46) (8)
     12 (24) | 13 (EU 46) (11) | 13 (EU 48) (8) | 13 (11)

   A shopper who wants a 10 has to know to click two chips. And the EU mapping
   contradicts itself — 12 maps to both EU 45 and EU 46, 13 to both EU 46 and
   EU 48 — so the EU numbers cannot all be right. The merged chip therefore
   shows the US size only. That is a LABELLING choice, not a data fix; the
   underlying values are untouched.

   Result: 8 chips — 8, 9, 9.5, 10, 10.5, 11, 12, 13 — each ticking every
   underlying value for that size in one submit.

   ================== THE THREE THINGS THAT WENT WRONG ==================
   All three shipped in the first version and all three were caught by testing
   the OUTCOME (submitted URL params, live result count) rather than the
   appearance of the list. Do not undo any of them.

   1. COUNTS INFLATED ON EVERY RE-RUN. apply() runs again after each swap, and
      it was re-summing counts it had already written: size 10 read 52, then
      77, then higher. Every count is now taken from data-rbb-shoe-orig,
      captured once on the row before anything is overwritten, so the pass is
      idempotent.

   2. ROWS sizeclean ALREADY MERGED WERE DOUBLE-COUNTED. sizeclean folds "09"
      into "9" and writes the combined 23 onto the "9" row. Summing every row
      in the bucket then counted that 1 twice. So the SUM skips rows sizeclean
      had already hidden, while the CLICK still ticks their inputs — otherwise
      picking 9 would silently miss the "09" product.

   3. stopPropagation BROKE THE FILTER ENTIRELY. The first version bound one
      delegated capture listener on the <ul> and stopped the event, to keep
      sizeclean's own listener on the "9" link from double-toggling. It did
      stop sizeclean — and the theme's handler with it. Clicking a chip
      submitted a form with no size params at all: URL came back with only
      sort_by and the price bounds, count stayed at 1923. The fix is to leave
      propagation alone and remove the competing listener instead: where
      sizeclean has bound one (data-rbb-merged), the link is replaced with a
      clone, which drops its listeners, and this module binds to the clone.
      Same preventDefault-only pattern sizeclean itself uses, which is known
      to work.

   THE COUNT IS A SUM and can in principle overstate, since summing facet
   counts double-counts a product carrying two merged values — that is what
   caught the pant dropdowns out (mockup predicted 404, real union was 272).
   Check a merged chip against the live result count, not the arithmetic.

   Loads AFTER rb-b-sizeclean.js and re-runs on a real swap only (rbbSwap). */

(function () {
  'use strict';

  /* NO BREAKPOINT GATE since 10 Sep — this runs on mobile too, with Mark's
     sign-off. The mobile drawer renders the identical .collection-sidebar
     markup and this module injects nothing and needs no CSS, so it is
     portable as-is. It is also the module that clears the worst of what the
     mobile drawer shows today: on /collections/footwear it takes the size
     list from 21 rows to 8, and it is what makes the bogus "Waist Sizes
     42 43 44 45" block above Shoe Sizes disappear there, because gatherEu
     moves those into the US chips and then hides the emptied heading. */

  /* ============ EU-ONLY SHOES FOLD INTO THE US CHIPS ============
     Five MOMA Allacciata Uomo styles are sold EU-only — their size option is
     literally 42/43/44/45 with no US equivalent — so the theme files them by
     SHAPE into the "Waist Sizes" bucket, nowhere near the shoes. A shopper
     browsing 8-13 could not find them at all, and a shopper who did click 44
     was clicking something the panel called a waist.

     They are now folded into the US chip for the same shoe. The map is the
     store's OWN data, not a conversion chart — it already sells:

       "9 (EU 42)"  22 products      "12 (EU 45)"  16 products
       "10 (EU 43)" 25 products
       "11 (EU 44)" 25 products

     46 and 48 are deliberately absent: the catalog calls EU 46 both US 12
     ("12 (EU 46)", 8 products) and US 13 ("13 (EU 46)", 11), so there is no
     honest fold for it. Nothing carries a plain 46 any more in any case —
     that was the Taylor Stitch Long Sleeve Shop Tee, which Mark re-sized to
     Medium/Large/X- Large/XX- Large on 10 Sep.

     Safe to translate unconditionally inside the shoe bucket: no US shoe
     size reaches 42, so a plain 42-45 there can only be EU.

     EARLIER DECISION REVERSED, deliberately. This was previously shipped as
     separate chips reading "EU 42 · US 9" (rb-b-pants.js placed them). Two
     reasons it changed: the objection to folding was that a Taylor Stitch
     shirt shared 42/44 and would have been filed under US 9 — that shirt is
     fixed, so only the five MOMA styles remain; and the wider labels cost
     footwear two chip rows, which put the panel back over its height cap
     ("i also dont want it to scroll if you can fit it all"). */
  var EU_TO_US = { 42: 9, 43: 10, 44: 11, 45: 12 };
  var EU_PLAIN = /^(4[2-5])$/;


  function isSubhead(el) {
    return !!(el && el.classList &&
      el.classList.contains('collection-sidebar__size-subheader'));
  }

  function rowLabel(row) {
    var el = row.querySelector('.collection-sidebar__link');
    if (!el) return '';
    var clone = el.cloneNode(true);
    var c = clone.querySelector('.collection-sidebar__link__count');
    if (c) c.remove();
    return clone.textContent.trim().replace(/\s+/g, ' ');
  }

  function readCount(row) {
    var c = row.querySelector('.collection-sidebar__link__count');
    var n = c ? parseInt((c.textContent || '').replace(/[^\d]/g, ''), 10) : NaN;
    return isNaN(n) ? 0 : n;
  }

  /* Captured once, before this module overwrites anything — see note 1. */
  function origCount(row) {
    if (!row.dataset.rbbShoeOrig) row.dataset.rbbShoeOrig = String(readCount(row));
    return parseInt(row.dataset.rbbShoeOrig, 10) || 0;
  }

  function setLabel(row, text) {
    var link = row.querySelector('.collection-sidebar__link');
    if (!link) return;
    var done = false;
    Array.prototype.forEach.call(link.childNodes, function (n) {
      if (n.nodeType === 3 && n.textContent.trim()) {
        n.textContent = done ? '' : text;
        done = true;
      }
    });
  }

  /* "10 (EU 43)" -> 10, "9.5" -> 9.5, "09" -> 9, "9 mm" -> null. */
  function usSize(label) {
    var s = (label || '').trim();
    if (/(oz|ml|mm|cm)\b/i.test(s)) return null;
    var m = s.match(/^0*(\d+(?:\.\d+)?)\s*(?:\(.*\))?$/);
    if (!m) return null;
    var n = parseFloat(m[1]);
    return isNaN(n) ? null : n;
  }

  function fmt(n) {
    return (Math.round(n * 10) % 10 === 0) ? String(Math.round(n)) : String(n);
  }

  /* Hide any subheading with nothing visible left under it. Moving the EU
     rows out can empty the heading they came from, and rb-b-pants.js runs
     BEFORE this module on the re-render path (110ms against 140ms), so it
     cannot be relied on to tidy up afterwards. */
  function hideEmptyHeads(ul) {
    var kids = Array.prototype.slice.call(ul.children);
    kids.forEach(function (el, i) {
      if (!isSubhead(el)) return;
      if (el.style.display === 'none') return;
      for (var j = i + 1; j < kids.length; j++) {
        if (isSubhead(kids[j])) break;
        if (getComputedStyle(kids[j]).display !== 'none') return;
      }
      el.style.setProperty('display', 'none', 'important');
    });
  }

  /* Move every EU-only shoe row into the shoe bucket so the normal merge
     below can fold it into a US chip. Creates the bucket when a collection
     has EU-only shoes and nothing else on the shoe axis (e.g. accessories,
     which carries one MOMA style among belts) — rather than renaming the
     heading those rows came from, which on that page sits over belts.
     Returns the index of the shoe subheading, or -1. */
  function gatherEu(ul) {
    var kids = Array.prototype.slice.call(ul.children);
    var start = -1, end = kids.length;
    for (var i = 0; i < kids.length; i++) {
      if (isSubhead(kids[i]) && /shoe/i.test(kids[i].textContent || '')) { start = i; break; }
    }
    if (start !== -1) {
      for (var j = start + 1; j < kids.length; j++) {
        if (isSubhead(kids[j])) { end = j; break; }
      }
    }

    var strays = [];
    kids.forEach(function (li, idx) {
      if (start !== -1 && idx > start && idx < end) return;   // already home
      if (!li.classList || !li.classList.contains('collection-sidebar__item')) return;
      if (li.dataset.rbbHidden === 'junk') return;
      var input = li.querySelector('input');
      if (!input) return;
      if (!EU_PLAIN.test((input.value || '').trim())) return;
      strays.push(li);
    });

    if (!strays.length) return start;

    var head = kids[start];
    if (start === -1) {
      var proto = ul.querySelector('.collection-sidebar__size-subheader');
      if (!proto) return -1;
      head = proto.cloneNode(false);          // same classes, no inherited text
      head.textContent = 'Shoe Sizes';
      head.dataset.rbbMade = '1';
      ul.appendChild(head);
    }

    var at = head;
    if (start !== -1) at = kids[end - 1] || head;   // after the last US row
    strays.forEach(function (li) {
      at.parentNode.insertBefore(li, at.nextSibling);
      at = li;
    });

    return Array.prototype.slice.call(ul.children).indexOf(head);
  }

  function apply() {
    var grp = document.querySelector('.collection-sidebar__filter-group--size');
    if (!grp) return;
    var ul = grp.querySelector('.collection-sidebar__items');
    if (!ul) return;

    var start = gatherEu(ul);
    if (start === -1) return;
    var kids = Array.prototype.slice.call(ul.children);

    var subhead = kids[start];
    var buckets = {};

    for (var j = start + 1; j < kids.length; j++) {
      var li = kids[j];
      if (isSubhead(li)) break;
      if (!li.classList || !li.classList.contains('collection-sidebar__item')) continue;
      if (li.dataset.rbbHidden === 'junk') continue;      // "9 mm" and friends

      var size = usSize(rowLabel(li));
      if (size === null) continue;

      /* An EU-only row folds into the US chip for the same shoe. Reading the
         INPUT VALUE rather than the label keeps this idempotent: the label
         has already been rewritten to "9" by the time the next pass runs. */
      var raw = (li.querySelector('input').value || '').trim();
      if (EU_PLAIN.test(raw)) size = EU_TO_US[raw];

      // Whether sizeclean had already folded this row away, BEFORE we touch it.
      var wasMerged = li.dataset.rbbHidden === 'merged';

      (buckets[size] = buckets[size] || []).push({
        li: li,
        wasMerged: wasMerged,
        count: origCount(li),
        input: li.querySelector('input')
      });
    }

    var keepers = [];

    Object.keys(buckets).forEach(function (key) {
      var set = buckets[key];

      // Never promote a row sizeclean hid; among the rest, highest count wins.
      set.sort(function (a, b) {
        return (a.wasMerged ? 1 : 0) - (b.wasMerged ? 1 : 0) || b.count - a.count;
      });

      var keep = set[0];
      if (keep.wasMerged) return;              // nothing visible for this size

      /* Skip rows sizeclean already folded in: their count is baked into the
         keeper's, and adding it again double-counts — see note 2. */
      var total = set.reduce(function (s, e) {
        return s + (e.wasMerged ? 0 : e.count);
      }, 0);

      // Every input though, merged or not, or the union misses products.
      var inputs = set.map(function (e) { return e.input; }).filter(Boolean);

      set.slice(1).forEach(function (e) {
        e.li.style.display = 'none';
        if (!e.li.dataset.rbbHidden) e.li.dataset.rbbHidden = 'shoe';
      });

      keep.li.style.display = '';
      setLabel(keep.li, fmt(parseFloat(key)));
      var countEl = keep.li.querySelector('.collection-sidebar__link__count');
      if (countEl) countEl.textContent = total;

      var link = keep.li.querySelector('.collection-sidebar__link');

      /* sizeclean may have bound its own handler here. Two listeners on the
         same element would toggle the shared inputs twice and cancel out, so
         drop its listeners by replacing the node — see note 3. */
      if (link && link.dataset.rbbMerged === '1' && link.dataset.rbbShoeBound !== '1') {
        var fresh = link.cloneNode(true);
        delete fresh.dataset.rbbMerged;
        link.parentNode.replaceChild(fresh, link);
        link = fresh;
      }

      if (link && link.dataset.rbbShoeBound !== '1') {
        link.dataset.rbbShoeBound = '1';
        link.title = 'US ' + fmt(parseFloat(key));

        /* preventDefault only. NO stopPropagation — the theme's own handler
           has to see this click or nothing is submitted at all. */
        link.addEventListener('click', function (ev) {
          ev.preventDefault();
          var turnOn = !inputs.some(function (x) { return x.checked; });
          inputs.forEach(function (x) { x.checked = turnOn; });
          if (inputs[0]) inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      keepers.push({ size: parseFloat(key), li: keep.li });
    });

    // Numeric order: 8, 9, 9.5, 10, 10.5, 11, 12, 13.
    keepers.sort(function (a, b) { return a.size - b.size; });
    var at = subhead;
    keepers.forEach(function (k) {
      at.parentNode.insertBefore(k.li, at.nextSibling);
      at = k.li;
    });

    hideEmptyHeads(ul);
  }

  function boot() {
    apply();

    var section = document.querySelector('.js-section__collection');
    if (!section || !window.MutationObserver) return;

    /* 140ms so sizeclean (90ms) has finished first — this reads the rows it
       hides and relabels. */
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () {
        if (window.rbbSwap && !window.rbbSwap.changed('shoes')) return;
        apply();
      }, 140);
    }).observe(section, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
